import {
  MANAGECATEGORY_FETCH_LIST_LOADING,
  MANAGECATEGORY_FETCH_LIST_SUCCESS,
  MANAGECATEGORY_FETCH_LIST_FAILED,
} from "../actions/manageCategory";

const defVal = {
  categoryListLoading: false,
  categoryList: [],

};

export default (state = defVal, action) => {
  switch (action.type) {
    case MANAGECATEGORY_FETCH_LIST_LOADING:
      return Object.assign({}, state, {
        categoryListLoading: true,
      });
    case MANAGECATEGORY_FETCH_LIST_SUCCESS:
      return Object.assign({}, state, {
        categoryListLoading: false,
        categoryList: action.categoryList,
        categoryListTotal: action.categoryListTotal,
      });
    case MANAGECATEGORY_FETCH_LIST_FAILED:
      return Object.assign({}, state, {
        categoryListLoading: false,
      });

    default:
      return state;
  }
};
